/** @file The seven bone transform channels in form order, with their scrub step and angle flag. */

/** Rotation and shear are degrees (the form shows a degree unit); scale scrubs in hundredths. */
export const TRANSFORM_CHANNELS = [
  { channel: 'x', step: 1, degrees: false },
  { channel: 'y', step: 1, degrees: false },
  { channel: 'rotation', step: 1, degrees: true },
  { channel: 'scaleX', step: 0.01, degrees: false },
  { channel: 'scaleY', step: 0.01, degrees: false },
  { channel: 'shearX', step: 1, degrees: true },
  { channel: 'shearY', step: 1, degrees: true },
] as const;
